/** Shared id for skip-link target — one `<main>` per route. */
export const MAIN_CONTENT_ID = "main-content";
